// extracted by mini-css-extract-plugin
export default {"container":"GameActive_container__RugiB","button":"GameActive_button__vF1bi","gameScreen":"GameActive_gameScreen__wAvCF","gamePanel":"GameActive_gamePanel__KmK22"};